var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_14618",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13914",
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_14618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x92\xBB\xE7\x9F\xB3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x92\xBB\xE7\x9F\xB32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x92\xBB\xE7\x9F\xB3_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x92\xBB\xE7\x9F\xB3_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 16168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 363",
    d: "M3.47713 20.0853L17.6323 34.9261C18.9397 36.2968 21.1274 36.2968 22.4347 34.9261L36.5899 20.0853C37.5288 19.101 37.7718 17.6434 37.2031 16.4078L33.7386 8.87992C33.3955 8.13448 32.7884 7.5426 32.0345 7.21857L28.0703 5.51477C27.6563 5.33686 27.2105 5.24512 26.76 5.24512H14.0508C13.6519 5.24512 13.2562 5.31706 12.8828 5.45749L8.13769 7.24196C7.32001 7.54946 6.65658 8.167 6.29136 8.96058L2.86395 16.4078C2.29526 17.6434 2.5383 19.101 3.47713 20.0853Z",
    fill: "url(#paint0_linear_1_14618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M37.4446 17.1655C37.6455 18.2043 37.3424 19.2967 36.5901 20.0854L22.4349 34.9263C21.1275 36.2968 18.9395 36.2969 17.6321 34.9263L3.47684 20.0854C2.72463 19.2968 2.42061 18.2043 2.62137 17.1655L10.9778 18.4546H29.0891L37.4446 17.1655Z",
    fill: "url(#paint1_linear_1_14618)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 364",
    filter: "url(#filter0_i_1_14618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9775 18.4547L13.5792 9.37305H26.7513L29.0892 18.4547L20.0334 35.7923L10.9775 18.4547Z",
    fill: "url(#paint2_linear_1_14618)",
    fillOpacity: 0.1
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_14618",
    x: 10.9775,
    y: 9.37305,
    width: 18.1118,
    height: 26.4194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65914
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_14618"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_14618",
    x1: 21.6801,
    y1: 9.37313,
    x2: 21.6801,
    y2: 34.1412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243878,
    stopColor: "#FE4092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771273,
    stopColor: "#FF94D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_14618",
    x1: 20.0331,
    y1: 21.7359,
    x2: 20.0331,
    y2: 35.9542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0344466,
    stopColor: "#FF2C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D85",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_14618",
    x1: 19.6217,
    y1: 12.6755,
    x2: 19.6217,
    y2: 37.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.4cbe3de3723b6527aca23a6143b66105.svg";
export { ForwardRef as ReactComponent };